import { SKIP_SYMBOL } from '../components/CycleTable/constants';
import CycleMeasurement from '../enums/cycle-measurement';
import getTempByMeasurement from './getTempByMeasurement';

const getValidTemperature = (
  temp: number | string | undefined,
  measurement: CycleMeasurement,
  skipValue: string = SKIP_SYMBOL,
) => {
  return typeof temp === 'number' ? getTempByMeasurement(measurement, temp) : skipValue;
};

export default getValidTemperature;
